export const fetchCurrentDialogSelector = (state) => state.fetchCurrentDialog.currentDialog
